import { Text } from '@chakra-ui/react';
import type { User } from '@halo/chat-sdk-react';
import { GroupAdminChangedAction, type Msg } from '@halo/chat-sdk-react';
import { Fragment } from 'react';
import { MyTrans } from '@halo/ui-react';
import { useUserInfo } from '@/scripts/hooks';
import { useUserInfoList } from '@/scripts/hooks/useUserInfoList';
import { MsgUserText } from '../../msg-parts';

export interface MsgGroupUpdateAdminsContentProps {
  message: Msg;
}

export const MsgGroupUpdateAdminsContent = memo(function MsgGroupUpdateAdminsContent({
  message,
}: MsgGroupUpdateAdminsContentProps) {
  const { t } = useTranslation();
  const { operator_user_id, action, admin_user_ids } = message.payload;

  const { user: operatorUser } = useUserInfo(operator_user_id);
  const { users: adminUsers } = useUserInfoList(admin_user_ids);

  return (
    <MyTrans
      i18nKey={
        action === GroupAdminChangedAction.Add
          ? t('chat.groupMessageAddAdminsText')
          : t('chat.groupMessageRemoveAdminsText')
      }
      components={{
        actionUser: <MsgUserText userName={operatorUser?.name || ''} userId={operator_user_id} />,
        action: <Text as="span" color="fg.muted" />,
        members: (
          <>
            {adminUsers?.map((item: User, index: number) => (
              <Fragment key={index}>
                {index > 0 && ', '}
                <MsgUserText userName={item?.name || ''} userId={item?.user_id || ''} />
              </Fragment>
            ))}
          </>
        ),
        other: <Text as="span" color="fg.muted" />,
      }}
    ></MyTrans>
  );
});
